import React from 'react';
import logoSvg from '../../assets/eduprocontracts.svg';
const Logo = ({ size = 'md', className = '' }) => {
    const sizes = {
        sm: 'h-5 w-auto',      // ~20px înălțime
        md: 'h-8 w-auto',      // ~32px înălțime (Header/Sidebar)
        lg: 'h-10 w-auto',     // ~40px înălțime
        xl: 'h-14 w-auto',     // ~56px înălțime
        '2xl': 'h-20 w-auto'   // ~80px înălțime (Login page)
    };

    return (
        <img
            src={logoSvg}
            alt="EduPro Contracts"
            className={`${sizes[size]} ${className}`}
        />
    );
};

export default Logo;